import { Search } from "lucide-react";
import "./ProviderFilters.css";

function ProviderFilters({
  filters,
  onChange,
}) {
  return (
    <div className="provider-filters">

      {/* Search */}

      <div className="provider-search">

        <Search size={18} />

        <input
          type="text"
          placeholder="Search providers..."
          value={filters.search}
          onChange={(e) =>
            onChange("search", e.target.value)
          }
        />

      </div>

      {/* Status */}

      <select
        value={filters.status}
        onChange={(e) =>
          onChange("status", e.target.value)
        }
      >
        <option value="">All Status</option>
        <option value="pending">Pending</option>
        <option value="approved">Approved</option>
        <option value="blocked">Blocked</option>
        <option value="rejected">Rejected</option>
      </select>

      {/* Provider Type */}

      <select
        value={filters.type}
        onChange={(e) =>
          onChange("type", e.target.value)
        }
      >
        <option value="">All Types</option>
        <option value="Home Chef">Home Chef</option>
        <option value="Restaurant">Restaurant</option>
        <option value="Hotel">Hotel</option>
        <option value="Bakery">Bakery</option>
        <option value="Cafe">Cafe</option>
        <option value="Catering">Catering</option>
        <option value="Provision Store">Provision Store</option>
      </select>

      {/* City */}

      <input
        type="text"
        placeholder="City"
        value={filters.city}
        onChange={(e) =>
          onChange("city", e.target.value)
        }
      />

      {/* Sort */}

      <select
        value={filters.sort}
        onChange={(e) =>
          onChange("sort", e.target.value)
        }
      >
        <option value="latest">Latest</option>
        <option value="oldest">Oldest</option>
        <option value="az">A - Z</option>
        <option value="za">Z - A</option>
      </select>

    </div>
  );
}

export default ProviderFilters;